import React, { useState } from 'react';
import Table from 'components/shared/table';
import { MoreHorizontal, Search } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'components/ui/Typography';
import { Button, Icon } from 'components/ui';
import { withSkillsClientWrapper } from 'components/shared/Skills/SkillsClientProvider';
import { withReactQueryWrapper } from 'components/shared/ReactQuery/ReactQueryProvider';
import { routes } from 'constants/config';
import Layout from '../../Learn/shared/Layout';
import MessageBanner from '../MessageBanner';
import SideNavBar from '../SideNavBar';
import { useGetSkillProfiles } from '../queries/skillProfiles';

const ProfileTableContainer = () => {
  const [bannerProperties] = useState({
    message: '',
    state: 'success',
  });
  const SORT_OPTIONS = {
    ASC: 'asc',
    DESC: 'desc',
    CATEGORY_ASC: 'category_asc',
    CATEGORY_DESC: 'category_desc',
  };
  const [tempSearchTerm, setTempSearchTerm] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [sort, setSort] = useState(SORT_OPTIONS.ASC);
  const page = offset / limit + 1;
  const { data: skillProfilesData } = useGetSkillProfiles({
    limit,
    offset,
    searchTerm,
    sort,
  });

  const sortIconName = sort.includes('asc') ? 'triangle_down' : 'triangle_up';
  const profiles = skillProfilesData?.profiles?.profiles ?? [];
  const totalCount = skillProfilesData?.profiles?.totalCount;
  const pageCount = Math.ceil(totalCount / limit);

  const renderSearch = () => (
    <div>
      <Search className="mr-n-5 c-gray-dark pos-a mt-6 ml-6" />
      <input
        className="SkillsLibrary-searchTermWidth h-36 ff-ss pl-32"
        icon={<Search />}
        placeholder={t('skills.profiles.search')}
        onChange={e => setTempSearchTerm(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            setSearchTerm(tempSearchTerm);
            setOffset(0);
          }
        }}
        value={tempSearchTerm}
      />
      {searchTerm && (
        <Icon
          className="ml-neg-24 mr-10 c-gray-dark"
          name="close-circle"
          onClick={() => {
            setSearchTerm('');
            setTempSearchTerm('');
          }}
        />
      )}
    </div>
  );

  return (
    <>
      {!!bannerProperties?.message && (
        <MessageBanner
          message={bannerProperties.message}
          state={bannerProperties.state}
        />
      )}
      <Layout.Main>
        <Layout.Side>
          <SideNavBar />
        </Layout.Side>
        <Layout.Content>
          <div>
            <div className="Index-header d-f">
              <h1 className="lh-26 fz-20 fw-600 c-brand-night">
                {t('skills.profiles.profiles')}
              </h1>
              <div className="d-f jc-r">
                {renderSearch()}
                <Button
                  type="button"
                  className="Button Button--linked ml-16"
                  icon="add"
                  onClick={() => {
                    window.location.assign(routes.SKILLS.PROFILE_ADD);
                  }}
                >
                  {t('skills.add_button')}
                </Button>
              </div>
            </div>
            <Table
              className="GradingStationTable Index-table--multipleHeaders mb-32 mt-24 bg-white border border-gray-light"
              alternate
              noBorderTop
              roundedBottom
            >
              <Table.Header>
                <Table.Header.Cell
                  className="Table-cell--xLarge Table-cell--clickable Table-cell--sortable"
                  onClick={() => {
                    if (sort === SORT_OPTIONS.ASC) {
                      setSort(SORT_OPTIONS.DESC);
                    } else {
                      setSort(SORT_OPTIONS.ASC);
                    }
                    setOffset(0);
                  }}
                >
                  <div className="d-f fd-r ai-c">
                    <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
                      {t('skills.profiles.job_titles')}
                    </Text>
                    <div className="icon ml-20">
                      <Icon
                        name={sortIconName}
                        className="Icon--small c-brand-gray c-p"
                      />
                    </div>
                  </div>
                </Table.Header.Cell>
                <Table.Header.Cell className="Table-cell--small">
                  <div className="d-f fd-r ai-c">
                    <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
                      {t('skills.profiles.number_of_skills')}
                    </Text>
                  </div>
                </Table.Header.Cell>
                <Table.Header.Cell className="Table-cell--xSmall" />
              </Table.Header>
              {profiles?.map(pr => (
                <Table.Row key={pr.title}>
                  <Table.BodyCell className="Table-cell--xLarge pl-24 border-right-0">
                    {pr.title}
                  </Table.BodyCell>
                  <Table.BodyCell className="Table-cell--small pl-24 border-right-0">
                    {pr.profileSkillCount}
                  </Table.BodyCell>
                  <Table.BodyCell className="Table-cell--xSmall">
                    <div className="icon">
                      <MoreHorizontal className="Icon--medium c-gray-darker" />
                    </div>
                  </Table.BodyCell>
                </Table.Row>
              ))}
              <Table.Footer className="p-12 border border-gray-light">
                <Table.Pagination
                  onPageChange={e => setOffset((e - 1) * 10)}
                  page={page}
                  pageCount={pageCount}
                  perPage={limit}
                  onPerPageChange={e => {
                    setLimit(e);
                    setOffset(0);
                  }}
                />
              </Table.Footer>
            </Table>
          </div>
        </Layout.Content>
      </Layout.Main>
    </>
  );
};

export default withSkillsClientWrapper(
  withReactQueryWrapper(ProfileTableContainer),
);
